'use strict'

var create = require('./util/create')

module.exports = create({
  space: 'xml',
  transform: xmlTransform,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
})

function xmlTransform(_, prop) {
  return 'xml:' + prop.slice(3).toLowerCase()
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-to-hyperscript/~/property-information/lib/xml.js
// module id = 200
// module chunks = 251080691916612